let _crypto = window.crypto;

if (_crypto == null && (window as any).msCrypto != null)
    _crypto = (window as any).msCrypto as Crypto; // Internet Explorer

function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
        (
            parseInt(c) ^
            (_crypto.getRandomValues(new Uint8Array(1))[0] &
                (15 >> (parseInt(c) / 4)))
        ).toString(16)
    );
}

const usedGuids: string[] = [];

export function createGuid() {
    const guid = uuidv4();
    if (usedGuids.indexOf(guid) === -1) usedGuids.push(guid);
    return guid;
}

export function createUniqueGuid() {
    let guid;
    do {
        guid = uuidv4();
    } while (usedGuids.indexOf(guid) !== -1);
    usedGuids.push(guid);
    return guid;
}
